import { XCircle } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'src/components/ui/button'
import { Card, CardContent } from 'src/components/ui/card'

const PaymentFailed = () => {

  const navigate = useNavigate();

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-red-50 to-rose-100">
      <Card className="w-full max-w-md rounded-2xl shadow-lg border-0">
        <CardContent className="flex flex-col items-center p-8 space-y-6">
          <XCircle className="h-20 w-20 text-red-500" />
          <h2 className="text-2xl font-bold text-gray-800">Payment Failed ❌</h2>
          <p className="text-gray-600 text-center">
            Something went wrong with your payment. Please try again or use a different method.
          </p>
          <div className="flex gap-4">
            <Button variant="outline" className="rounded-xl px-6 py-2" onClick={() => navigate("/books")}>
              Go to Books
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default PaymentFailed